import { Button as ButtonPrimitive } from '@base-ui/react/button';
import { cn } from '#lib/utils.ts';

import { buttonFocusRingClasses } from './constants.ts';

export type BareButtonProps = Omit<ButtonPrimitive.Props, 'className'> & {
  className?: string;
};

function BareButton({ className, type = 'button', ...props }: BareButtonProps) {
  return (
    <ButtonPrimitive
      data-slot="button"
      type={type}
      className={cn(
        'cursor-pointer rounded-md disabled:pointer-events-none disabled:opacity-50',
        buttonFocusRingClasses,
        className,
      )}
      {...props}
    />
  );
}

export { BareButton };
